import React, { useEffect, useState } from 'react';

/**
 * Notion OAuth Callback Page
 * This page handles the callback from Notion OAuth authentication
 */
const NotionCallback = () => {
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    // Extract the code from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      setStatus('error');
      return;
    }

    if (code) {
      // Store the code in localStorage for the parent window to access
      localStorage.setItem('notion_temp_code', code);
      setStatus('success');
      
      // Close this window after a short delay
      setTimeout(() => {
        window.close();
      }, 1500);
    } else {
      setStatus('error');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
        {status === 'processing' && (
          <>
            <div className="animate-spin h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"></div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">Processing Notion Authentication</h1>
            <p className="text-gray-600">Please wait while we complete the authentication process...</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="mx-auto mb-4 text-green-500">
              <svg className="h-12 w-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">Authentication Successful!</h1>
            <p className="text-gray-600">You have successfully authenticated with Notion. This window will close automatically.</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="mx-auto mb-4 text-red-500">
              <svg className="h-12 w-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="text-xl font-bold text-gray-800 mb-2">Authentication Failed</h1>
            <p className="text-gray-600">There was an error authenticating with Notion. Please close this window and try again.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default NotionCallback; 